export const trackLeadConversion = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-18330176945/xiNcCJmK9tEcELGbwaRE',
      value: 1.0,
      currency: 'UAH',
    });
  }
};

export const trackCalculatorConversion = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-18330176945/qk3aCOnuktIcELGbwaRE',
      value: 1.0,
      currency: 'UAH',
    });
  }
};
